import { useAuth } from '@/lib/auth'
import { getDashboardDefaultPath } from '@/lib/dashboard-shell'
import { Navigate } from '@tanstack/react-router'

export default function IndexRoute() {
  const { isAuthenticated, isLoading, user } = useAuth()
  if (isLoading) {
    return <div className="grid min-h-dvh place-items-center text-sm text-slate-500">載入中...</div>
  }
  return <Navigate to={isAuthenticated ? getDashboardDefaultPath(user) : '/login'} />
}
